import { GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'NoteAttachment',
    components: {
        GlIcon
    },
    props: {
        attachment: {
            type: Object,
            required: true
        }
    }
};
